// Central, easily-replaceable brand + placeholder media. Swap these URLs to update artwork site-wide.
export const MEDIA = {
  logoPrimary: "/brand/logo_primary.png",
  logoStacked: "/brand/logo_stacked.png",
  logoArc: "/brand/logo_circle_arc.png",
  logoFull: "/brand/logo_full.png",
  logoBone: "/brand/logo_bone.png",
  logoCircle: "/brand/logo_circle_arc.png",
  founder: "/brand/founder.jpg",
  chewieCutout: "/brand/chewie_cutout.png",
  soloCutout: "/brand/solo_cutout.png",
  // Real Chewie & Solo photography (client-approved master references)
  heroDogs: "/brand/pair_feature.png",
  chewie: "/brand/chewie_feature.png",
  solo: "/brand/solo_feature.png",
  bookCover: "/brand/book_cover.jpg",
  // Collection tile imagery (placeholder product mockups)
  collectionBooks: "/brand/book_cover.jpg",
  collectionClothing: "https://static.prod-images.emergentagent.com/jobs/938fa448-0e33-4f89-b80b-983b1372918b/images/377a86d5879b4d29c56856adbe7718229888c833d8f5175f1a41583bd3c56a60.jpeg",
  collectionStickers: "https://static.prod-images.emergentagent.com/jobs/938fa448-0e33-4f89-b80b-983b1372918b/images/196c4ab913c1b860aee1c4b428f46c362d343832b311ed04f1ac3599cb28a6dd.jpeg",
  collectionDogs: "https://static.prod-images.emergentagent.com/jobs/938fa448-0e33-4f89-b80b-983b1372918b/images/fcfd466304b0f85befad0a0eb9c7a8aa0d8b2b02764fd2a8056260927b603973.jpeg",
  collectionAccessories: "https://static.prod-images.emergentagent.com/jobs/938fa448-0e33-4f89-b80b-983b1372918b/images/f33f707774cb262097de5a6a3e9812bb6c291522773f3420bbdb1420cfaa09d8.jpeg",
  collectionGifts: "https://static.prod-images.emergentagent.com/jobs/938fa448-0e33-4f89-b80b-983b1372918b/images/babe3baa46a83bb8f94b8df8b09c65c3493d4dab9f1296091affe88e9311a536.jpeg",
};

export const COLORS = {
  yellow: "#FFD93D",
  pink: "#FF6B9D",
  aqua: "#4CC9F0",
  green: "#7ED957",
  purple: "#A78BFA",
  navy: "#19324A",
  cream: "#FFF9EE",
};

export const formatAUD = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(n);
